interface Config {
  infoSecURL: string;
  intakeFormURL: string;
  maxFileSize: number;
}

const config: Config = {
  infoSecURL:
    "https://www.mypepsico.com/wps/myportal/web/MyPepsiCo/company/departments-and-functions/information-security/infosec-policy-standards/data-classification/!ut/p/z1/jZBPC4JAEMU_keysmOhxNbPU7Q9Y2V5i0LQFU3ElqE-fRR06ZM5hYOD33sw8IkhCRIVXWWAn6wrLfj4I87i2PHMegB76nFHYrJZuHNszP-SU7F8A96lJHQMiiAGA0YBZ09ACakyIGKOHH8VgnH4AEMP2wb8FfQJ6y11eENFgd9ZkldckeXZ1SrWmLmV601SHVYZtpkiSYYdaWqJSMpfpK8f-SPG9ZrXwPGAO7DaGa4MbTd7Arxx1-gcwPg4DrzaX7Ta5R3OQi-IBw1r_IQ!!/dz/d5/L2dBISEvZ0FBIS9nQSEh/",

  intakeFormURL:
    "https://pepsico.service-now.com/esc?id=emp_taxonomy_topic&topic_id=22bd2399c3201690dd0cd29a050131c6",

  maxFileSize: 50 * 1024 * 1024,
};

export default config;

export const sessionStorageKeys = {
  sessionKey: "currentChatSessionId",
  questionKey: "activeQuestionId",
};
